import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@ochal/auth';
import { hasPermission, PermissionProvider } from '@ochal/permissions';
import { usePlatformRuntime } from '@ochal/react-runtime';
import { LoadingState } from '@ochal/ui';
import { fa } from '../i18n/fa';

export function ProtectedRoute({ permission, featureFlag, children }: { permission?: string; featureFlag?: string; children: ReactNode }) {
  const runtime = usePlatformRuntime();
  const { session, loading, sessionExpired } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingState label={fa.state.checkingSession}/>;
  if (sessionExpired) return <Navigate to="/login?reason=session-expired" replace/>;
  if (!session) return <Navigate to="/login" replace state={{ from: location }}/>;
  if (!runtime.features.isEnabled(featureFlag, { roles: [session.user.role] })) return <Navigate to="/404" replace/>;
  if (!hasPermission(session.user, permission)) return <Navigate to="/403" replace/>;
  return <PermissionProvider user={session.user}>{children}</PermissionProvider>;
}
